import { VFC, Fragment } from "react";
import { nodeDefs } from "src/nodes";
import { DataFieldType } from "src/types/data-field.types";
import { NodeData, NodeInstance } from "src/types/node.types";
import { CheckboxField } from "./fields/checkbox";
import { DateField } from "./fields/date";
import { NumberField } from "./fields/number";
import { SelectField } from "./fields/select";
import { TextField } from "./fields/text";

export interface EditableNodeDataProps {
  node: NodeInstance;
  onChange: (data: NodeData) => void;
}

export const EditableNodeData: VFC<EditableNodeDataProps> = (props) => {
  const nodeDef = nodeDefs[props.node.type];

  return (
    <>
      {nodeDef.fields.map((field, index) => {
        return (
          <Fragment key={index}>
            {field.type === DataFieldType.TEXT && (
              <TextField
                field={field}
                data={props.node.data}
                onChange={props.onChange}
              />
            )}

            {field.type === DataFieldType.NUMBER && (
              <NumberField
                field={field}
                data={props.node.data}
                onChange={props.onChange}
              />
            )}

            {field.type === DataFieldType.BOOLEAN && (
              <CheckboxField
                field={field}
                data={props.node.data}
                onChange={props.onChange}
              />
            )}

            {field.type === DataFieldType.DATE && (
              <DateField
                field={field}
                data={props.node.data}
                onChange={props.onChange}
              />
            )}

            {field.type === DataFieldType.SELECT && (
              <SelectField
                field={field}
                data={props.node.data}
                onChange={props.onChange}
              />
            )}
          </Fragment>
        );
      })}
    </>
  );
};
